import Link from 'next/link';

import { UspBarProps } from './UspBar.types';
import { Icon, Text } from '@goed/ui-components';

export const UspBar = ({ ...props }: UspBarProps) => {
    const { usps, callToAction } = props;

    return (
        <div className="usp-bar">
            <ul className="usp-bar__list">
                {usps
                    //@ts-ignore
                    .filter((usp) => usp.location === 'uld' || usp.location === 'both')
                    .map((usp, index) => (
                        <Text key={`usp-${index}`} tagName="li" className="usp-bar__list__item" variant="xsmall">
                            <Icon name="check" size={16} className="usp-bar__list__check" />
                            {usp.title}
                        </Text>
                    ))}
            </ul>
            {callToAction && callToAction.__typename === 'ExternalLinkRecord' && callToAction.url && (
                <Link href={callToAction.url}>
                    <a
                        className="usp-bar__link"
                        target={callToAction.openInNewWindow ? '_blank' : undefined}
                        rel={callToAction.openInNewWindow ? 'noreferrer noopener' : undefined}
                    >
                        <Text tagName="span" variant="xsmall">
                            {callToAction.label}
                        </Text>
                        <Icon name="external-link" size={20} />
                    </a>
                </Link>
            )}
        </div>
    );
};
